// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"i2-z","dimensionLabel":"j2-z","styleChooserControlWrapper":"k2-z","styleChooserControl":"l2-z","disabled":"m2-z","giftCard":"n2-z","styleChooserText":"o2-z"};